
import translations from './ComparisonArea.translations'

export default {
  computed: {
    translations: () => translations,
  },
}
